export default  {
  require: {
  },
  controller: 'daySingleSelectController',
  template: require('../views/day.single.select.html')
};



// WEBPACK FOOTER //
// ./frontend/admin/app/modules/days/components/day.single.select.component.js